import React from 'react'
import './style.css';
import { useNavigate } from 'react-router-dom';

export default function ProjectListCard({project}) {
    const navigate = useNavigate();
    const handleProjectClick =()=>{
        navigate(`/project/${project.id}`)
    }

    return (
        <div onClick={handleProjectClick} className='project-list-card-main'>
            <img src={require(`../../../assets/images/projects/${project.image}`)} className='project-list-card-image' />
            <p className='project-list-subtitle'>{project.role} · {project.type} · {project.tech} · {project.year}</p>
            <p className='project-list-title'> {project.title}</p>
        </div>
    )
}
